import React from "react";
import { useFormContext } from "react-hook-form";
import { Button, Text } from "$components";
import useJStyles from "$hooks/useJStyles";
import { useDockyardFormContext } from "../context/DockyardFormContext";
import { useDockyardStyles } from "../styles";

import { CompanySection } from "../sections/CompanySection";
import { ProjectSection } from "../sections/ProjectSection";
import { BasicInfoSection } from "../sections/BasicInfoSection";
import { AddressSection } from "../sections/AddressSection";
import { InterveningCompaniesSection } from "../sections/InterveningCompaniesSection";
import { NotesSection } from "../sections/NotesSection";
import { AttachmentsSection } from "../sections/AttachmentsSection";
import { ApproverSection } from "../sections/ApproverSection";

type Props = {
  onSubmit: (data: any) => Promise<any>;
  onCancel: () => void;
};

export default function DockyardFormContent({ onSubmit, onCancel }: Props) {
  const form = useFormContext();
  const { jclasses } = useJStyles();
  const classes = useDockyardStyles();
  const {
    dockyard,
    currentCompany,
    isSubmitting,
    error,
    contributorOptions,
    code,
    name,
  } = useDockyardFormContext();

  return (
    <div className={jclasses.jWrapper}>
      <Text type="h2">
        {dockyard ? `Chantier : [${code}] ${name}` : "Ajouter un chantier"}
      </Text>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          form.handleSubmit(onSubmit)(e);
        }}
        className={classes.form}
      >
        <CompanySection />
        <ProjectSection />
        <BasicInfoSection />
        <AddressSection />
        <div style={{ height: 20 }} />

        {contributorOptions?.length > 0 && <InterveningCompaniesSection />}

        {currentCompany && <ApproverSection />}

        <NotesSection />

        {currentCompany && <AttachmentsSection />}

        {error && <Text className={classes.errorField}>{error}</Text>}

        <div className={classes.footerForm}>
          <Button color="secondary" onClick={onCancel}>
            Annuler
          </Button>
          <Button type="submit" disabled={isSubmitting}>
            Enregistrer
          </Button>
        </div>
      </form>
    </div>
  );
}
